import {permissoes, routesNames} from '@/core/constants'
import GestaoDaAtaRoute from '@/views/routers/routes/ata/gestao-da-ata/gestao-da-ata'
import AtaView from '@/views/pages/ata/pesquisa/AtaView'
import AcessarAtaView from '@/views/pages/ata/acessar/AcessarAtaView.vue'
import GestaoDoPedidoRoute from '@/views/routers/routes/ata/gestao-de-pedido/gestao-do-pedido'
import ProcessoDigitalAtaRoute from '@/views/routers/routes/ata/processo-digital/processo-digital'
import RegistroPreco from "@/views/pages/ata/RegistroPreco.vue";
import ProcessoUtilizacaoView from "@/views/pages/processo-utilizacao/ProcessoUtilizacaoView.vue";
import FiscaisRoute from '@/views/routers/routes/ata/fiscais/fiscais'
import PenalidadesRoute from '@/views/routers/routes/ata/penalidades/penalidades'
import AditivoApostilaView from "@/views/pages/ata/acessar/aditivo-apostila/AditivoApostilaView.vue";
import ProcessoDigitalAditivoApostila
	from "@/views/routers/routes/ata/processo-digital-aditivo-apostila/processo-digital-aditivo-apostila";
import PedidoAbaView from '@/views/pages/pedido/PedidoAbaView.vue'

export default [
	{
		name: routesNames.ATA.REGISTRO_PRECO_VIEW,
		path: '/registroPreco',
		component: RegistroPreco,
		meta: {
			menu: {
				title: 'Ata de Registro de Preços',
				icon: 'library_books',
			},
			page: {
				title: 'Ata de Registro de Preços',
			},
			requiresAuth: true,
			authorities: [permissoes.ataMenu],
		},
		children: [
			{
				name: routesNames.ATA.ATA_VIEW,
				path: '/ata',
				component: AtaView,
				meta: {
					menu: {
						title: 'Atas RP',
					},
					page: {
						title: 'Atas de Registro de Preços',
					},
					requiresAuth: true,
					authorities: [permissoes.ataMenu],
				},
			},
			{
				name: routesNames.PEDIDO.PEDIDO_ABA_VIEW,
				path: '/pedidos',
				component: PedidoAbaView,
				meta: {
					menu: {
						title: 'Pedidos',
					},
					page: {
						title: 'Pedidos',
					},
					requiresAuth: true,
					authorities: [permissoes.pedidoUtilizacaoVisualizar],
				},
			},
			{
				name: routesNames.PROCESSO_UTILIZACAO.PROCESSO_UTILIZACAO_VIEW,
				path: '/processoUtilizacao',
				component: ProcessoUtilizacaoView,
				meta: {
					menu: {
						title: 'Processo de Utilização',
					},
					page: {
						title: 'Processo de Utilização',
					},
					requiresAuth: true,
					authorities: [permissoes.processoUtilizacaoListar],
				},
			},
		],
	},
	...ProcessoDigitalAtaRoute,
	{
		name: routesNames.ATA.ATA_ACESSAR_VIEW,
		path: '/ata/:id/',
		component: AcessarAtaView,
		meta: {
			page: {
				title: 'Ata de Registro de Preço',
				subtitle: 'Acessar',
			},
			requiresAuth: true,
			authorities: [permissoes.ataVisualizar, permissoes.ataEditar],
		},
		children: [GestaoDaAtaRoute, GestaoDoPedidoRoute, PenalidadesRoute, FiscaisRoute],
	},
	{
		name: routesNames.ATA.ATA_ACESSAR_ADITIVO_APOSTILA_VIEW,
		path: '/ata/:id/aditivo-apostila/:idAditivoApostila',
		component: AditivoApostilaView,
		meta: {
			page: {
				title: 'Aditivo/Apostila',
				subtitle: 'Editar',
			},
			requiresAuth: true,
			authorities: [permissoes.aditivoApostilaCriar, permissoes.aditivoApostilaEditar, permissoes.aditivoApostilaHistorico],
		},
	},
	...ProcessoDigitalAditivoApostila
]
